import { put } from "redux-saga/effects";

import { topicsApiSlice } from "api/topicsApi.slice";
import { activateModal } from "domains/modal/actions";
import { router } from "router/router";

type HandleCustomTopicUpdateFailureSagaProps = { errorStatus: number; pathname: string };

export function* handleCustomTopicUpdateFailureSaga({
  errorStatus,
  pathname,
}: HandleCustomTopicUpdateFailureSagaProps) {
  if (errorStatus === 401) {
    return;
  }
  const topicNotFoundError = [403, 404].includes(errorStatus);
  const params = topicNotFoundError
    ? ({ localisedMessageKey: "app.topic.unavailable.error_message" } as const)
    : undefined;
  yield put(activateModal({ id: "Error", params }));
  yield put(topicsApiSlice.util.invalidateTags(["CustomMaps"]));
  const isCurrentlyCreatePath = pathname.includes("create");
  yield router.navigate(isCurrentlyCreatePath ? "/create" : "/discover");
}
